// --------------------------------------------------------------------------------
export const enum PortKeys {
    FileUrl = 'file_url'
}
// --------------------------------------------------------------------------------
export interface PdfViewerData {
    theme: ePdfViewerTheme;
}
// --------------------------------------------------------------------------------
export enum ePdfViewerTheme {
    light = 'light',
    dark = 'dark'
}
// --------------------------------------------------------------------------------
export interface PdfViewerState {
    fileUrl: string;
}
// --------------------------------------------------------------------------------